module.exports = __webpack_public_path__ + "static/img/ahzx.c63abc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ahzx.png
// module id = Bvki
// module chunks = 1